module.exports = __webpack_public_path__ + "img/icon-empty@2x.c9374056.png";